import { render, staticRenderFns } from "./UserUploadModal.vue?vue&type=template&id=2bc357d0&"
import script from "./UserUploadModal.vue?vue&type=script&lang=js&"
export * from "./UserUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./UserUploadModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports